import styled from 'styled-components';

/**
 * hover 카드 내부 스타일.
 *
 * 카드 자체(위치·그림자·배경)는 `GanttView/styles.ts` 의 `StyledHoverCard` 가 갖는다 —
 * 여기서는 **내용의 층위**만 정한다: 제목 > 기간 > 분류·메모(흐리게).
 */
export const StyledTitle = styled.div`
  font-weight: 700;
  font-size: 13px;
  line-height: 1.4;
`;

export const StyledPeriod = styled.div`
  margin-top: 2px;
  font-variant-numeric: tabular-nums;
`;

/** 분류·담당·계획 표기 — 보조 정보라 한 단계 낮춘다 */
export const StyledMeta = styled.div`
  opacity: 0.75;
`;

export const StyledDivider = styled.hr`
  margin: 6px 0;
  border: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.18);
`;

export const StyledSectionLabel = styled.div`
  margin-bottom: 2px;
  font-size: 11px;
  font-weight: 600;
  opacity: 0.6;
`;

/**
 * 쿠폰 한 줄 — 혜택을 왼쪽에 고정폭으로 두어 여러 개일 때 숫자가 세로로 정렬된다.
 * `·` 로 이어붙이면 어디까지가 한 쿠폰인지 읽히지 않는다.
 */
export const StyledCouponRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 6px;

  .benefit {
    flex: 0 0 52px;
    text-align: right;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }

  .name {
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const StyledMemo = styled.div`
  opacity: 0.8;
  white-space: pre-line;
`;

/** 조회 구간 밖까지 이어지는 항목 안내 — 드래그가 막힌 이유를 알린다 */
export const StyledClipNotice = styled.div`
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed rgba(255, 255, 255, 0.18);
  font-size: 11px;
  line-height: 1.5;
  color: #fcd34d;
`;
